import Card from "@/components/UI/Card/Card";
import Button from "@/components/UI/Button/Button";
import styles from "./SuggestionCard.module.css";

interface SuggestionCardProps {
  productName: string;
  patientName: string;
  uploadedOnText: string;
  date: string;
  addLabel: string;
  imageUrl: string;
  imageAlt?: string;
  onAddClick: () => void;
  className?: string;
  isLoading?: boolean;
}

export default function SuggestionCard({
  productName,
  patientName,
  uploadedOnText,
  date,
  addLabel,
  imageUrl,
  imageAlt = "",
  onAddClick,
  className,
  isLoading = false,
}: SuggestionCardProps) {
  return (
    <Card className={`${styles.suggestionCard} ${className || ""}`.trim()}>
      <div className={styles.imageWrapper}>
        <img
          src={imageUrl}
          alt={imageAlt || productName}
          className={styles.image}
        />
      </div>

      <div className={styles.infoBox}>
        <span className={styles.productName}>{productName}</span>
        <span className={styles.patientName}>{patientName}</span>
        <div className={styles.dateText}>
          {uploadedOnText} <span className={styles.dateBold}>{date}</span>
        </div>
      </div>

      <Button variant="primary" onClick={onAddClick} disabled={isLoading}>
        {isLoading ? <div className={styles.loader}></div> : addLabel}
      </Button>
    </Card>
  );
}
